import { render, staticRenderFns } from "./route-detail.vue?vue&type=template&id=c09888b0&"
import script from "./route-detail.vue?vue&type=script&lang=js&"
export * from "./route-detail.vue?vue&type=script&lang=js&"
import style0 from "./route-detail.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports